import { Grid, TextField, MenuItem, Typography } from "@mui/material"
import { IInternForm } from "../DialogCadastrarRecb"
import { permitirApenasNumeros } from "../../../../../../../../../../../helpers/masks"
import { useState } from "react";

export default function CartaoForm({
                                       values,
                                       handleChangeValues
                                   }: CartaoFormProps) {
    const configuracoesCartao = values.formaPagamento?.configuracoes_cartao;
    const [parcelas, setParcelas] = useState(1);

    const handleParcelasChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setParcelas(Number(e.target.value));
        handleChangeValues("cartao_parcelas", Number(e.target.value));
    };

    return (
        <Grid container size={{xs: 12}} spacing={2}>
            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    fullWidth
                    label='Nsu'
                    type="text"
                    value={values.cartao_nsu || ''}
                    onChange={(e) => {
                        const format = permitirApenasNumeros(e.target.value)
                        handleChangeValues("cartao_nsu", format)
                    }}
                />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    fullWidth
                    label='Autorização'
                    type="text"
                    value={values.cartao_autorizacao || ''}
                    onChange={(e) => handleChangeValues("cartao_autorizacao", e.target.value)}
                />
            </Grid>

            {configuracoesCartao?.situacao === 19 && (
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        fullWidth
                        select
                        label="Parcelas"
                        value={parcelas}
                        onChange={handleParcelasChange}
                    >
                        {[...Array(values.formaPagamento?.maximo_parcelas)].map((_, i) => (
                            <MenuItem key={i+1} value={i+1}>
                                {i+1}x
                            </MenuItem>
                        ))}
                    </TextField>
                    <Typography variant="caption" color="text.secondary">
                        Selecione a quantidade de parcelas
                    </Typography>
                </Grid>
            )}
        </Grid>
    )
}

interface CartaoFormProps {
    values: IInternForm,
    handleChangeValues: (prop: keyof IInternForm, value: any) => void
}